import { registerTokenGetter } from "@/shared/auth/tokenProvider";
import { useAuth0 } from "@auth0/auth0-react";
import { useEffect } from "react";

export function AuthTokenBridge() {
  const { getAccessTokenSilently, isAuthenticated } = useAuth0();

  useEffect(() => {
    registerTokenGetter(async () => {
      if (!isAuthenticated) return undefined;
      try {
        return await getAccessTokenSilently();
      } catch {
        return undefined;
      }
    });
  }, [getAccessTokenSilently, isAuthenticated]);

  return null;
}
